export const en = {
    beta_test_notification:
        'Service is being on Beta testing stage. We are activly working on it and waiting for your ',
    create_trip: 'Create travel request',
    create_trip_description: 'Select the services your need for your trip',
    feedback: 'feedback.',
    my_trips: 'My travel requests',
    trips_loading: 'Loading business trips',
};
